// eslint-disable-next-line strict
module.exports = require('form-data');



//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/env/classes/FormData.js
// module id = WnJR
// module chunks = 142